import { color, media, Text, Button, BlockText } from '@morressier/ts';

import { FaArrowDown } from 'react-icons/fa';
import styled, { css } from 'styled-components';
import Grid from 'styled-components-grid';

export const CopyDoiButton = styled(Button)`
  && {
    border-radius: 24px 0 0 24px;
    ${media.medium`
      margin-right: 1rem;
      border-radius: 3px;
    `}
  }
`;

export const DownloadButton = styled(Button)`
  && {
    border-radius: 0 24px 24px 0;
    ${media.medium`
      border-radius: 3px;
    `}
  }
`;

export const DownIcon = styled(FaArrowDown)`
  color: ${color('grey')};
`;

export const ContentButton = styled(Button)`
  && {
    border-radius: 1.5rem;
    margin: 0.5rem 0;
    width: 100%;
  }

  &&:disabled {
    color: ${color('white')};
    background-color: ${color('lightGrey')};
  }

  &&:focus {
    z-index: unset;
  }

  ${media.medium`
    && {
      margin: 0.5rem;
      width: auto;
    }
  `};
`;

export const ArticleSummary = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: left;
  margin-top: 1.5rem;
`;

export const ArticleStatistics = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
  color: ${color('secondaryBrand')};
  && > svg {
    position: relative;
    margin: 0 0.5rem;
    color: ${color('secondaryBrand')};
  }
  ${media.medium`
    margin: 0.5rem;
    width: auto;
  `}
`;

export const HeroButtonContainer = styled.div`
  box-shadow: 0 15px 15px 0 rgba(12, 15, 18, 0.38);
  border-radius: 1.5rem;
  ${media.medium`
    margin-left: auto;
    display: inline-block;
    box-shadow: none;
    border-radius: unset;
    white-space: nowrap;
  `}
`;

export const HeroWrapper = styled.div`
  padding: 2rem 1rem 2rem;
  background-color: ${color('sidebarGrey')};
  margin-bottom: 2rem;
  ${media.medium`
    padding: 1.5rem 2rem 2rem;
  `}
`;

export const StyledText = styled(Text)`
  margin-left: 2rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  ${media.medium`
    width: calc(100% - 25rem);
    &:before {
      left: 7rem;
      top: 1.5rem;
    }
  `}
`;

export const HeroTop = styled.div<{ hasScrollStarted: boolean }>`
  display: flex;
  padding: 1rem;
  padding-left: 0;
  align-items: center;
  position: sticky;
  top: 4rem;
  background-color: ${color('sidebarGrey')};
  background-color: ${props => (props.hasScrollStarted ? color('white') : color('sidebarGrey'))};
  box-shadow: ${props => props.hasScrollStarted && '0 0 0.5rem 0 rgba(0, 0, 0, 0.4)'};
  text-align: left;
  transition-duration: 1s;
  transition-property: background-color, box-shadow;
  z-index: 3;
`;

export const SectionContainer = styled.div`
  max-width: 100%;

  ${media.large`
    width: 80rem;
    margin: 0 auto;
  `}
`;

export const BackToPageLinkWrapper = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0;
  white-space: nowrap;
  ${media.large`
    position: relative;
    border-bottom: none;
    margin-left: 0;
  `};
`;

export const VideoSectionGrid = styled(Grid)`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  ${media.medium`
    width:100%;
    position: static;
    margin: 0;
  `}
`;

export const VideoPlayerColumn = styled(Grid.Unit).attrs(() => ({
  size: { medium: 8 / 12 },
}))``;

export const VideoInfoColumn = styled(Grid.Unit).attrs(p => ({
  size: { medium: p.hasVideo ? 4 / 12 : 1 },
}))`
  padding: 1rem 2rem 0;
  ${media.medium`
    padding-top: 0;
    ${props => (props.hasVideo ? 'padding-left: 2rem' : 'padding-left: 0rem')} ;
  `}
`;

export const Thumbnail = styled.img`
  cursor: pointer;
  min-width: 100%;
  max-width: 100%;
  margin: 0;
  box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.2);
  border-radius: 3px 3px 0 0;
`;

export const ZeroStateBox = styled.div`
  background-color: rgb(252, 252, 253);
  border: 1px solid rgb(212, 213, 214);
  border-radius: 3px;
`;

export const ZeroStateBoxWrapper = styled.div`
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Card = styled.a`
  text-decoration: none;
  color: unset;
  > div {
    &:hover {
      border-color: ${color('secondaryBrand')};
      box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.2);
      transition: 0.5s border-color, 0.5s box-shadow;
    }
  }
`;

export const ProductLabel = styled(BlockText).attrs(() => ({
  size: 'body1_new',
  color: 'grey',
}))`
  text-transform: uppercase;
  line-height: 1.5rem;
`;

export const GrayBox = styled.div`
  width: 3rem;
  height: 3rem;
  background-color: rgb(216, 216, 216);
`;

export const TextWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PdfWrapper = styled.div<{ disableDownload?: boolean }>`
  height: calc(100vh - 192px);
  width: 100%;
  position: relative;

  ${props =>
    props.disableDownload &&
    css`
      .block-download {
        content: '';
        position: absolute;
        right: 0;
        top: 55px;
        width: 100%;
        height: calc(100% - 55px);
        overflow-y: scroll;
      }
      .block-buttons {
        content: '';
        position: absolute;
        right: 2.5rem;
        top: 0;
        width: 12rem;
        height: 4.375rem;
        cursor: not-allowed;
      }
      .block-buttons:hover {
        > span {
          display: block;
          height: 100%;
          width: 100%;
          > span {
            display: block;
          }
        }
      }
    `}
`;
